






























































































import Vue from 'vue';
import store from '@/store';
import { defaultTo } from 'lodash';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { DocumentList } from '@/components/my-documents-components/document-list-components';
import { VaultDataResponseModel } from '@/@types/member';

export default Vue.extend({
  name: 'MyDocuments',
  beforeRouteEnter(to, from, next) {
    const promises = [store.dispatch('getVaultData')];
    LoadingService.watchPromises(promises)
      .then(() => {
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  computed: {
    submittedDocuments(): VaultDataResponseModel[] {
      return this.$store.getters.submittedDocuments;
    },
    unsubmittedDocuments(): VaultDataResponseModel[] {
      return this.$store.getters.unsubmittedDocuments;
    },
    totalUnsubmittedAmount(): number {
      return this.unsubmittedDocuments.reduce(function(accumulator, document) {
        return accumulator + defaultTo(document.amount, 0);
      }, 0);
    },
    hasDocuments(): boolean {
      return !!(
        this.submittedDocuments.length || this.unsubmittedDocuments.length
      );
    },
  },
  components: {
    DocumentList,
  },
});
